import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store/index";
import ApiPurchaseHistory from "@/api/ApiPurchaseHistory";

import {
  MultimediaPurchaseHistoryListResponse,
  MultimediaPurchaseHistoryResponse,
} from "@API/src/component/memoruHome/purchaseHistory/types";
import {
  FetchPurchaseHistoryListRequest,
  FetchPurchaseHistoryRequest,
  CancelPurchaseHistoryRequest,
} from "@/model/request/purchaseHistory";
import { MultimediaCartItemListResponse, MultimediaCartItemResponse } from 'chaild-entity/src/component/memoruHome/cart/types';

export interface PurchaseHistoryState {
  histories: MultimediaPurchaseHistoryListResponse | null;
  historyDetails: MultimediaCartItemListResponse | null;
}

@Module({ dynamic: true, store, name: "purchaseHistory", namespaced: true })
class PurchaseHistoryModule extends VuexModule implements PurchaseHistoryState {
  public histories: MultimediaPurchaseHistoryListResponse | null = null;
  public historyDetails: MultimediaCartItemListResponse | null = null;

  @Action({ rawError: true })
  public async fetchPurchaseHistoryList(
    request: FetchPurchaseHistoryListRequest
  ) {
    const response: MultimediaPurchaseHistoryListResponse =
      await ApiPurchaseHistory.fetchPurchaseHistoryList(request);
    this.setPurchaseHistories(response);
    return response;
  }

  @Mutation
  public setPurchaseHistories(
    purchaseHistories: MultimediaPurchaseHistoryListResponse
  ) {
    this.histories = purchaseHistories;
  }

  @Action({ rawError: true })
  public async fetchPurchaseHistory(
    request: FetchPurchaseHistoryRequest
  ) {
    const response: MultimediaCartItemListResponse =
      await ApiPurchaseHistory.fetchPurchaseHistory(request);
    this.setPurchaseHistoryDetails(response)
    return response;
  }

  @Mutation
  public setPurchaseHistoryDetails(
    purchaseHistory: MultimediaCartItemListResponse
  ) {
    this.historyDetails = purchaseHistory;
  }

  @Action({ rawError: true })
  public async cancelPurchaseHistory(request: CancelPurchaseHistoryRequest) {
    await ApiPurchaseHistory.cancelPurchaseHistory(request);
    return true;
  }
}

export const purchaseHistoryModule = getModule(PurchaseHistoryModule);
